<template>
  <div class="input-document">
    <div>
      <small v-if="!content && value && value.linkId" @click="dialogVisible = true">Attention le contenu précedemment lié n'existe plus.</small>
      <div class="document" v-else-if="content">
        <span @click="dialogVisible = true">{{ content.document[entity.displayField] }}</span>
        <span>
          <el-button @click="dialogVisible = true" class="el-button el-button--small">Modifier le lien</el-button>
          <el-button class="el-button el-button--small" @click="clear()">Supprimer le lien</el-button>
          <router-link class="el-button el-button--small" target="_blank"
              :to="{ name: 'editor-content', params: {
                spaceId: spaceId,
                entityId: entityId,
                contentId: content.contentId,
                versionId: content.versionId
              }}"
            >
              Consulter
          </router-link>
        </span>
      </div>
      <div class="document" v-else>
        <span>Pas de contenu lié</span>
        <el-button @click="dialogVisible = true" class="el-button el-button--small">Lier un contenu</el-button>
      </div>
    </div>

     <el-dialog title="Choisir un contenu" :visible.sync="dialogVisible" @open="fetchContents()">

      <div class="document" v-for="c in contents" :key="c.contentId" :class="{ active: content && content.contentId === c.contentId }"
        @click="select(c.contentId)">
          <slot v-if="entity">{{ entity.name }} - {{ c.document[entity.displayField] }}</slot>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Fermer</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: 'input-document',
  props: ['value', 'entityId', 'spaceId', 'lang'],
  data() {
    return {
      entity: null,
      content: null,
      document: null,
      contents: null,

      dialogVisible: false,
    };
  },
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.entity = await api.getEntity(this.spaceId, this.entityId);
      if (this.value) this.content = await api.getContent(this.spaceId, this.entityId, this.value.linkId, this.lang);
    },
    async fetchContents() {
      if (this.dialogVisible && !this.contents) {
        this.contents = await api.getContents(this.spaceId, this.entityId);
      }
    },
    select(id) {
      this.content = this.contents.find(c => c.contentId === id);

      this.$emit('input', {
        type: 'document',
        spaceId: this.$route.params.spaceId,
        linkId: id,
      });
    },
    clear() {
      this.content = null;
      this.$emit('input', null);
    },
  },
};
</script>

<style lang="sass">
.input-document
  > div
    small
      display: block
      padding: 1rem 0 1.5rem
      color: #aaaaaa
  .el-dialog__body
    max-height: 80vh
    overflow-y: scroll
    span
      display: inline-block
      padding: 0.5rem
      .image
        width: 200px
  .document
    display: flex
    align-items: center
    justify-content: space-between
    margin: 0.2rem 0
    padding: 0.6rem 0.8rem 0.4rem
    font-size: 0.9rem
    background: #FAFAFA
    border-radius: 4px
    cursor: pointer
    border: 3px solid transparent

  .active
    border-color: #ff3c48
    border-radius: 2px
</style>
